// compare-plans.hooks.ts
import { PLANS, SANCTUM_FEATURES } from "../billing.constants";

export type ComparePlansProps = {
    /** Navigate back to Billing tab */
    onGoBack?: () => void;
    /** Open Sanctum upgrade flow (North Star) on Billing */
    onUpgradeToNorthStar?: () => void;
};

export const useComparePlans = ({
    onGoBack,
    onUpgradeToNorthStar,
}: ComparePlansProps) => {
    const handleGoBack = () => {
        if (onGoBack) {
            onGoBack();
        }
    };

    const handleUpgradeToNorthStar = () => {
        if (onUpgradeToNorthStar) {
            onUpgradeToNorthStar();
        }
    };

    const sanctumFeatures = SANCTUM_FEATURES;
    const northStarUpsellFeatures = PLANS.northStar.upsellFeatures;

    return {
        handleGoBack,
        handleUpgradeToNorthStar,
        sanctumFeatures,
        northStarUpsellFeatures,
    };
};
